module.exports = __webpack_public_path__ + "img/plane.43c63820.png";